import { useState } from 'react';
import { ThemeProvider } from 'styled-components';

import { lightTheme } from 'theme';

import { CREATOR_PROFILE } from '../constants';
import * as styled from '../styles/creator-hero';
import { BrandingCustomizer } from './branding-customizer';
import { ProfileCard } from './profile-card';

type Props = {
  onClaimLink: () => void;
  onSeeExample: () => void;
};

export const CreatorHero = ({ onClaimLink, onSeeExample }: Props) => {
  const [themePreset, setThemePreset] = useState<LandingV2.ThemePreset>('personal');
  const [accentColor, setAccentColor] = useState<string | null>(null);
  const [avatarBorderColor, setAvatarBorderColor] = useState<string | null>(null);

  return (
    <styled.Wrap>
      <styled.Intro>
        <styled.Badge>
          <styled.BadgeDot />
          <styled.BadgeLabel>For content creators</styled.BadgeLabel>
        </styled.Badge>

        <styled.Heading>Your bio link, but it closes deals.</styled.Heading>

        <styled.Description>
          One page with your rate card, the brands you&apos;ve worked with, and reviews from
          campaigns you were paid for. Everything a brand asks for before they send a brief.
        </styled.Description>

        <styled.CtaRow>
          <styled.PrimaryCta type="button" onClick={onClaimLink}>
            Claim your link
          </styled.PrimaryCta>
          <styled.SecondaryCta type="button" onClick={onSeeExample}>
            See an example
          </styled.SecondaryCta>
        </styled.CtaRow>

        <styled.Footnote>kudable.com/p/yourname · free</styled.Footnote>
      </styled.Intro>

      <styled.DemoRow>
        <BrandingCustomizer
          themePreset={themePreset}
          accentColor={accentColor}
          avatarBorderColor={avatarBorderColor}
          onThemeChange={setThemePreset}
          onAccentChange={setAccentColor}
          onBorderChange={setAvatarBorderColor}
        />
        <ThemeProvider theme={lightTheme}>
          <ProfileCard
            data={CREATOR_PROFILE}
            accentColor={accentColor}
            avatarBorderColor={avatarBorderColor}
            themePreset={themePreset}
          />
        </ThemeProvider>
      </styled.DemoRow>
    </styled.Wrap>
  );
};
